import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

/**
 * International Number Format string helper
 * @category numbers
 * @param {String} amount The amount to be formatted.
 * @param {String} currency The currency to use.
 * @param {String} lang The language to format by.
 */
function formatCurrency(amount, currency, lang, digits) {
  var options = {
    style: "currency",
    currency: currency
  };

  if (typeof digits !== "undefined") {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = digits;
  }

  return new Intl.NumberFormat(lang || "en-US", options).format(amount);
}
/**
 * International Number Format string helper for numbers with radix
 * @category numbers
 * @param {String} lang The language to format by.
 */


function formatFloat(number, lang) {
  return new Intl.NumberFormat(lang || "en-US").format(number);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Collection helpers
 * @category collection
 * @param {array} collection Collection to iterate on
 * @param {number} itemId The ID to look for
 * @param {function} newItem function to perform on the found item
 */


function updateCollectionObjectByItemId(collection, itemId, newItem) {
  var updatedCollection = collection.map(function (item) {
    // Return items that we don't want to change
    if (item.id !== itemId) return item; // Match!

    return Object.assign({}, item, _objectSpread2({}, newItem));
  });
  return updatedCollection;
}
/**
 * Replace item in an immutable array
 * @category collection
 * @param {array} items Array of items to update
 * @param {object} item New item
 * @param {number} index The index of the item to update
 */


function replaceItemAtIndex(items, item, index) {
  return [].concat(_toConsumableArray(items.slice(0, index)), [item], _toConsumableArray(items.slice(index + 1)));
}
/**
 * Removes an item in a collection that matches the ID, and returns a new collection
 * @category collection
 * @param {array} collection Collection in which to find the item to remove
 * @param {number} id ID to remove
 */


function removeItemById(collection, id) {
  var index = collection.findIndex(function (x) {
    return x.id === id;
  });
  return [].concat(_toConsumableArray(collection.slice(0, index)), _toConsumableArray(collection.slice(index + 1)));
}

export { formatCurrency, formatFloat, removeItemById, replaceItemAtIndex, updateCollectionObjectByItemId };